const hasErrors = (errors: any) => {
  return Object.keys(errors).length > 0;
};

export default hasErrors;
